import { useNavigate } from 'react-router-dom';

const RetryButton = () => {
    const navigate = useNavigate();

    return (
        <button
            className="w-full px-6 py-3 theme-button font-semibold rounded-lg transition-colors duration-200 focus:ring-2 focus:ring-offset-2 focus:ring-offset-primary"
            onClick={() => navigate('/')}
        >
            برگشت به صفحه اصلی
        </button>
    );
};

export default RetryButton;

